import universal from 'react-universal-component';
import universalImport from 'babel-plugin-universal-import/universalImport';
import path from 'path';
import { timeout } from 'yoda-site-components/lib/lazy/lazyConstants';

export default universal(
    universalImport({
        chunkName: () => 'VisitStoreToPurchaseLazy',
        path: () => path.join(__dirname, './VisitStoreToPurchase'),
        resolve: () => require.resolveWeak('./VisitStoreToPurchase'),
        load: () =>
            Promise.all([
                import(/* webpackChunkName: "VisitStoreToPurchase" */ './VisitStoreToPurchase'),
            ]).then((proms) => proms[0]),
    }),
    {
        loading: () => null,
        error: () => null,
        timeout,
    }
);
